import { Component } from "@angular/core";
import { keysToTranslate } from "i18n/keys-to-translate";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { LoggingService } from "../../log/logging.service";
import { MenuTreeItem } from "../../core/services/menu/menu-tree-item";
import { AppMenuService } from "../../core/services/menu/app-menu.service";
import { BreadcrumbService } from "../../core/services/breadcrumb.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../environments/environment";
import { AppPermissionService } from "../../core/services/app-permission.service";
import { FormatConfigService } from "../../core/services/format-config.service";
import { AbstractComponent } from "../../shared/components/abstract-component/abstract.component";
import { AppImageConfig } from "../../core/services/app-image-config";
import { ImageConfigEntry } from "../../core/base-api";
import { MizenAngularLibService } from "mizen-angular-lib";

@Component({
  selector: "cap-intercapi-dashboard",
  styleUrls: ["./intercapi-layout.component.scss"],
  templateUrl: "./intercapi-layout.component.html",
})
export class IntercapiLayoutComponent extends AbstractComponent {
  keycloakPasswordChangeUrl: string;
  keycloakEmailChangeUrl: string;
  root: MenuTreeItem;

  passwortAendernParam =
    !!this.formatService.parameterConfig?.parameters
      .PASSWORT_IN_INTERCAPI_AENDERN;
  emailAendern =
    !!this.formatService.parameterConfig?.parameters
      .EMAIL_IN_INTERCAPI_AENDERN && !environment.bbvEnabled;

  private imageElementToImagePathMapping: Map<ImageConfigEntry.ElementEnum,
    string> = new Map();
  logoPath: string;

  constructor(
    private menuService: AppMenuService,
    private router: Router,
    public location: Location,
    private translate: TranslateService,
    private breadcrumbService: BreadcrumbService,
    private permissionService: AppPermissionService,
    private formatService: FormatConfigService,
    private mizenAngularLibService: MizenAngularLibService,
    public service: LoggingService
  ) {
    super();
    keysToTranslate<string>([
      "layouts.toolbar.de",
      "layouts.toolbar.fr",
      "layouts.page.title",
      "layouts.page.titleNavigation",
      "layouts.settings",
      "layouts.entwicklungsUmgebung",
      "layouts.testUmgebung",
      "layouts.GeschichteEinAus",
    ]);
    this.addSub(
      this.menuService.menu$.subscribe(
        (value: MenuTreeItem) => (this.root = value)
      )
    );
    this.calculateKeycloakUrls();
    this.translate.onLangChange.subscribe(_ => {
      this.calculateKeycloakUrls();
    });

    this.initAppLogo();
  }

  private calculateKeycloakUrls() {
    this.keycloakPasswordChangeUrl = this.keycloakUrl("/account/password");
    this.keycloakEmailChangeUrl = this.keycloakUrl("/account");
  }

  private keycloakUrl(additionalPath: string): string {
    const passwordUrl = new URL(environment.openIdConnect.issuer);
    passwordUrl.pathname = passwordUrl.pathname + additionalPath;
    this.addQueryParams(passwordUrl);
    return passwordUrl.toString();
  }

  private addQueryParams(url: URL) {
    url.searchParams.append("origin", window.location.origin + this.location.prepareExternalUrl(""));
    url.searchParams.append("kc_locale", this.translate.currentLang ?? 'de');
  }

  private initAppLogo() {
    this.imageElementToImagePathMapping.set("APP_LOGO_DEFAULT", "");
    this.imageElementToImagePathMapping.set(
      "APP_LOGO_BS",
      "assets/img/wappen/bs.png"
    );
    this.addSub(
      this.formatService.imageConfig$.subscribe((config) =>
        this.updateLogo(config)
      )
    );

  }

  private updateLogo(imageConfig: AppImageConfig) {
    if (!imageConfig) {
      return;
    }
    const configuredImageElement =
      imageConfig.getImageFormatForCurrentLanguage("APP_LOGO");
    if (configuredImageElement && configuredImageElement.element) {
      this.logoPath = this.imageElementToImagePathMapping.get(
        configuredImageElement.element
      );
    }
    if (!this.logoPath) {
      this.logoPath =
        this.imageElementToImagePathMapping.get("APP_LOGO_DEFAULT");
    }
  }

  isMizenEnabled(): boolean {
    return this.mizenAngularLibService.isEnabled();
  }

  get hasPermissionConfigManager() {
    return this.permissionService.hasPermission("CONFIGMANAGER");
  }
}
